<template>
  <p>
    VIZBI 2017, the 8<sup>th</sup> international meeting on Visualizing Biological Data, was held
    14&ndash;16 June 2017 at the
    <a href="https://sydney.edu.au/perkins/" target="_blank" rel="nofollow">Charles Perkins Centre</a>
    in Sydney, Australia, sponsored by The University of Sydney, The Garvan Institute of Medical
    Research, and Destination New South Wales.
  </p>
  <HeroImage hero-image="Hero.png" flyer-hi-res="Poster.pdf" />
  <p>
    VIZBI 2017 featured keynotes from
    <a href="http://www.vis.uni-konstanz.de/en/members/keim" target="_blank" rel="nofollow">Daniel Keim</a>,
    <a href="http://www.cs.ubc.ca/~tmm" target="_blank" rel="nofollow">Tamara Munzner</a>, and
    <a href="http://www.wehi.edu.au/people/drew-berry" target="_blank" rel="nofollow">Drew Berry</a>,
    in addition to talks from 18 world-leading researchers showcasing visualizations transforming how
    life scientists view data, and driving key advances in molecular biology, systems biology,
    biomedical science, and ecology.
  </p>
  <p>
    The conference brought together a diverse community, including bioinformaticians, data scientists,
    computer scientists, and experimentalists, as well as medical illustrators, graphic designers, and
    graphic artists. VIZBI 2017 was part of
    <a href="https://www.vividsydney.com/" target="_blank" rel="nofollow">Vivid Sydney</a> &mdash; a
    spectacular festival of light, music, and ideas.
  </p>
  <p>
    All participants had the opportunity to present a
    <router-link to="Posters">poster and lightning talk</router-link> describing their work.
  </p>
  <p>
    As with previous meetings, VIZBI 2017 was an exciting event that helped raise the standard of
    data visualization in the life sciences. Highlights from the meeting are available on the VIZBI
    <router-link to="/blog">blog</router-link>,
    <router-link to="/Posters/2017">posters</router-link>,
    <router-link to="/photos/2017">photos</router-link>, and
    <router-link to="/videos">videos</router-link> pages.
  </p>
  <p>
    To receive updates about VIZBI, you can join the
    <router-link to="/SignUp">VIZBI mailing list</router-link>.
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>
